import styled from 'styled-components';

import { LoadingText as BaseLoadingText } from './styled.base';

export * from './styled.base';

export const LoadingText = styled(BaseLoadingText)`
  width: 20rem;
  margin: 0;
`;
